module.exports = __webpack_public_path__ + "img/FR10228.1a6ced68.png";